import { ActivatedRoute } from '@angular/router';
import { AddTicketNoteModalFormComponent } from 'src/app/forms-modal/_tickets/add-ticket-note-modal-form/add-ticket-note-modal-form.component';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, firstValueFrom, forkJoin, Subscription, throwError } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyModalFormComponent } from 'src/app/forms-modal/_company/company-modal-form/company-modal-form.component';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, eSimApiPaths, GridViewTitles } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { environment } from 'src/environments/environment';
import { eUser } from 'src/app/core/enums';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { InformationModalFormComponent } from '../../_pop-ups/information-modal-form/information-modal-form.component';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { Ticket } from 'src/app/core/models/system/support/ticket-hub/ticket';
import { TicketHubService } from 'src/app/core/services/utelize/system/support/ticket-hub/ticket-hub.service';
import { TicketModalFormComponent } from 'src/app/forms-modal/_tickets/ticket-modal-form/ticket-modal-form.component';
import { UserModalFormComponent } from 'src/app/forms-modal/_user/user-modal-form/user-modal-form.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { Validators } from '@angular/forms';

const exportFilenameSuffix="Tickets";
const mainTitle           =GridViewTitles.manageTickets;
const parentSection       ="Support";
const thisSection         =GridViewTitles.manageTickets;
const popUpTitle          ="Ticket";

@Component({
  selector: 'app-manage-tickets',
  templateUrl: './manage-tickets-modal-form.component.html',
  styleUrls: ['./manage-tickets-modal-form.component.scss'],
  providers: [GridViewService]
})

export class ManageTicketsModalFormComponent implements OnInit, OnDestroy {
  @Input() companyId?              : number;
  @Input() deviceId?               : number;
  @Input() userId?                 : number;
  @Input() initialInviewCompanyId? : number;
  @Input() initialSureSimDeviceId? : number;
  @Input() initialInviewUserId?    : number;
  @Input() isCompany               : boolean = true;
  @Input() isDevice                : boolean = false;
  @Input() isUser                  : boolean = false;
  @Input() matchCompanyAndUser     : boolean = false;
  @Input() newCompany              : boolean = false;
  @Input() newSim                  : boolean = false;
  @Input() newUser                 : boolean = false;
  
  @ViewChild('companyModalForm',    { static: false }) companyModalForm!    : CompanyModalFormComponent;
  @ViewChild('gridView',            { static: false }) gridView!            : GridViewComponent;
  @ViewChild('informationModalForm',{ static: false }) informationModalForm!: InformationModalFormComponent;
  @ViewChild('manageEsimModalForm', { static: false }) manageEsimModalForm! : ManageEsimModalFormComponent;
  @ViewChild('ticketModalForm',     { static: false }) ticketModalForm!     : TicketModalFormComponent;
  @ViewChild('ticketNotesModalForm',{ static: false }) ticketNotesModalForm!: AddTicketNoteModalFormComponent;
  @ViewChild('userModalForm',       { static: false }) userModalForm!       : UserModalFormComponent;

  get enableSupportOnNew() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.EnableSupportOnNew, false); }
  
  get columnMinWidth() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.GridDefaultColumnMinWidth, 150); }

  private companyModalFormIsOpen    : boolean=false;
  private curUser                   : SystemUserDTO;
  private curUserID                 : number;
  private gridViewDefaults!         : GridViewDefaults;
  private manageEsimFormIsOpen      : boolean=false;
  private routeQueryParamSub        : Subscription | undefined;
  private subscription              : Subscription = new Subscription();
  private ticketModalFormIsOpen     : boolean=false;
  private ticketNotesModalFormIsOpen: boolean=false;
  private userModalFormIsOpen       : boolean=false;

  public apiPath                    : string="";
  public breadCrumbItems!           : Array<{}>;
  public curUserInviewCompanyID     : number | undefined;
  public dgApiPath!                 : DgApiPath | undefined;
  public dgActionColumn!            : DgActionColumn | undefined;
  public dgColumns!                 : Array<DgColumn>;
  public dgPopup!                   : DgPopup | undefined;
  public dgTabs!                    : Array<DgTab>;
  public dgProperties!              : DgProperties | undefined;
  public gotDgProperties            : boolean=false;
  public pendingTicketFilter        : string | undefined;
  public title                      : string=mainTitle;

  public navItemLog_OpenTickets     : number=1;          
  public navItemLog_ClosedTickets   : number=2;
  public activeId                   : number=1;

  constructor(
    private authenticationService     : AuthenticationService,
    private companiesService          : CompaniesService,
    private componentAccessUserService: ComponentAccessUserService,
    private gridViewService           : GridViewService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService,
    private route                     : ActivatedRoute,
    private usersService              : UsersService,
    private ticketHubService          : TicketHubService 
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.curUserID       =this.authenticationService.currentUserObject().userId;
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
    this.curUserInviewCompanyID=this.authenticationService.currentUserObject().inviewCompanyId;
    this.apiPath    = environment.eSimApi+eSimApiPaths.Tickets+ "/" + eSimApiPaths.GetUserAndCompanyTickets; 
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.routeQueryParamSub?.unsubscribe();
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.subscription = this.ticketHubService.ticketCreated$.subscribe(async _ => {
        this.apiPath    = environment.eSimApi+eSimApiPaths.Tickets+ "/" + eSimApiPaths.GetUserAndCompanyTickets;
        await this.setDgApiPathGet();
      });

      if (this.shouldUseRouteTicketFilter()) {
        this.pendingTicketFilter=this.route.snapshot.queryParamMap.get('ticket')?.trim() || undefined;
        this.routeQueryParamSub?.unsubscribe();

        this.routeQueryParamSub=this.route.queryParamMap.subscribe(params => {
          this.pendingTicketFilter=params.get('ticket')?.trim() || undefined;
          this.applyPendingTicketFilter();
        });
      }
  
      this.breadCrumbItems = [
        { label: parentSection },
        { label: thisSection, active: true }
      ];

      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgProperties();
      this.setUpDgTabs();
      this.setUpDgPopup();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(this.apiPath);
      this.dgApiPath!.refreshGet=() => this.buildDgApiPathGet();

      await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn                 =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowDeleting  =false;
      this.dgActionColumn!.allowMore      =true;
      this.dgActionColumn!.allowUpdating  =false;
      this.dgActionColumn!.moreIcon       ="assets/images/_suresim/Button View 55x23.png";
      this.dgActionColumn!.width          =DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public manageEsimFormHasBeenCancelled() {
    try {
      this.manageEsimFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async orderDataHasBeenSaved(): Promise<void> {
    try {
      this.manageEsimFormIsOpen=false;
      
      await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties                     =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      this.dgProperties!.checkbox0          =this.gridViewDefaults.setUpDgCheckbox("Horizontal Scroll & Fixed Columns",
                                                                                   true,
                                                                                   false,
                                                                                   false,
                                                                                   this.columnMinWidth>0);
      this.dgProperties!.columnHidingEnabled=true;
      this.dgProperties!.columnMinWidth     =undefined;
      this.dgProperties!.encryptDeleteSS    =true;
      this.dgProperties!.encryptPost        =true;
      this.dgProperties!.encryptPut         =true;
      this.dgProperties!.gridKey            ="ManageTicketsModalForm";
      this.dgProperties!.initialTab         =this.navItemLog_OpenTickets;
      this.dgProperties!.showAddButton      =true;
      this.dgProperties!.showTabs           =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //Ticket ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "Ticket ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=true;//this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];

      //Date Opened
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("created_at", "Date Opened", "", DgColumnDataType.date);
      dgColumn!.gridVisible=true;
      this.dgColumns.push(dgColumn!);

      //CompanyName
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("company", "Company", "", DgColumnDataType.string);
      dgColumn!.cellTemplate    ="CompanyNameTemplate";
      dgColumn!.cellTemplateType="link"
      this.dgColumns.push(dgColumn!);

      //Type of issue
      dgColumn            =this.gridViewDefaults.setUpDgColumn("type", "Type", "", DgColumnDataType.string);
      dgColumn!.validators=[Validators.required, Validators.maxLength(20)];
      this.dgColumns.push(dgColumn!);

      //Raised By
      dgColumn             =this.gridViewDefaults.setUpDgColumn("requester", "Raised By", "", DgColumnDataType.string);
      dgColumn!.formVisible=false;
      this.dgColumns.push(dgColumn!);

      //Affected User
      dgColumn             =this.gridViewDefaults.setUpDgColumn("affectedUser", "Affected User", "", DgColumnDataType.string);
      dgColumn!.formVisible=false;
      this.dgColumns.push(dgColumn!);

      //ICCID
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("iccid", "ICCID", "", DgColumnDataType.string);
      dgColumn!.width             =172;
      // dgColumn!.cellTemplate    ="ICCIDTemplate";
      // dgColumn!.cellTemplateType="link"
      this.dgColumns.push(dgColumn!);      

      //Status
      dgColumn            =this.gridViewDefaults.setUpDgColumn("status", "Status", "", DgColumnDataType.string);
      dgColumn!.validators=[Validators.required, Validators.maxLength(20)];
      this.dgColumns.push(dgColumn!);

      //Title
      dgColumn            =this.gridViewDefaults.setUpDgColumn("title", "Title", "", DgColumnDataType.string);
      dgColumn!.validators=[Validators.required, Validators.maxLength(20)];
      this.dgColumns.push(dgColumn!); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabs() {
      try {
        let dgTab: DgTab | undefined;
        
        //Open Tickets
        dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_OpenTickets, "Open Tickets");
        this.dgTabs       =[dgTab!];
  
        //Closed Tickets
        dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_ClosedTickets, "Closed Tickets");
        this.dgTabs.push(dgTab!);
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
      }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async onTabChange(event: any): Promise<void> {
    try {
      this.activeId = <number>event;
      await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async buildDgApiPathGet(): Promise<void> {
    try {
      // if (this.configSystemService.paramsLoaded) {
      if (this.newCompany || this.newSim || this.newUser) {

        const { companyIdEncResult,
                userIdEncResult,
                deviceIdEncResult,
                openTicketsEncResult,
                matchCompanyAndUserEncResult }=await firstValueFrom(
                  forkJoin({
                    companyIdEncResult          : this.encryptionService.encrypt_AesServerSideForWeb("0", true),
                    userIdEncResult             : this.encryptionService.encrypt_AesServerSideForWeb("0"),
                    deviceIdEncResult           : this.encryptionService.encrypt_AesServerSideForWeb("0"),
                    openTicketsEncResult        : this.encryptionService.encrypt_AesServerSideForWeb("true"),
                    matchCompanyAndUserEncResult: this.encryptionService.encrypt_AesServerSideForWeb("true")
                  })
                );

        const companyIdEncSS        =companyIdEncResult.result;
        const userIdEnc             =userIdEncResult.result;
        const deviceIdEnc           =deviceIdEncResult.result;
        const openTicketsEnc        =openTicketsEncResult.result;
        const matchCompanyAndUserEnc=matchCompanyAndUserEncResult.result;
        
        this.dgApiPath!.get=environment.eSimApi+eSimApiPaths.Tickets+ "/" + eSimApiPaths.GetUserAndCompanyTickets +
                             "?companyIdEncSS="         + companyIdEncSS + 
                             "&userIdEnc="              + userIdEnc + 
                             "&deviceIdEnc="            + deviceIdEnc + 
                             "&openTicketsEnc="         + openTicketsEnc + 
                             "&matchCompanyAndUserEnc=" + matchCompanyAndUserEnc;

      } else {
        let openTickets=this.activeId == this.navItemLog_OpenTickets;

        const { companyIdEncResult,
                userIdEncResult,
                deviceIdEncResult,
                openTicketsEncResult,
                matchCompanyAndUserEncResult }=await firstValueFrom(
                  forkJoin({
                    companyIdEncResult          : this.encryptionService.encrypt_AesServerSideForWeb((this.companyId ?? -1).toString(), true),
                    userIdEncResult             : this.encryptionService.encrypt_AesServerSideForWeb((this.userId ?? -1).toString()),
                    deviceIdEncResult           : this.encryptionService.encrypt_AesServerSideForWeb((this.deviceId ?? -1).toString()),
                    openTicketsEncResult        : this.encryptionService.encrypt_AesServerSideForWeb(openTickets.toString()),
                    matchCompanyAndUserEncResult: this.encryptionService.encrypt_AesServerSideForWeb(this.matchCompanyAndUser.toString())
                  })
                );

        const companyIdEncSS        =companyIdEncResult.result;
        const userIdEnc             =userIdEncResult.result;
        const deviceIdEnc           =deviceIdEncResult.result;
        const openTicketsEnc        =openTicketsEncResult.result;
        const matchCompanyAndUserEnc=matchCompanyAndUserEncResult.result;
        
        this.dgApiPath!.get=environment.eSimApi+eSimApiPaths.Tickets+ "/" + eSimApiPaths.GetUserAndCompanyTickets +
                             "?companyIdEncSS="         + companyIdEncSS + 
                             "&userIdEnc="              + userIdEnc + 
                             "&deviceIdEnc="            + deviceIdEnc + 
                             "&openTicketsEnc="         + openTicketsEnc + 
                             "&matchCompanyAndUserEnc=" + matchCompanyAndUserEnc;
      }

      this.gridViewService.apiPathGet=this.dgApiPath!.get;
      // }
      // else {
      //   setTimeout(() => { this.setDgApiPathGet(); }, 1000);
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async setDgApiPathGet(): Promise<void> {
    try {
      await this.buildDgApiPathGet();

      if (this.gridView != null)
        this.gridView.refreshData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridContentReady() {
    try {
      this.applyPendingTicketFilter();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private shouldUseRouteTicketFilter(): boolean {
    return !this.isCompany && !this.isDevice && !this.isUser;
  }

  private applyPendingTicketFilter() {
    try {
      if (!this.shouldUseRouteTicketFilter())
        return;

      const filterText=this.pendingTicketFilter?.trim();

      if (!filterText || !this.gridView?.dataGrid?.instance)
        return;

      this.gridView.dataGrid.instance.searchByText(filterText);
      this.pendingTicketFilter=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyClick(companyName : string) {
      try {
        if (!this.companyModalFormIsOpen) {
          this.companyModalFormIsOpen=true;
          
          this.companiesService.getIdByCompanyName(companyName)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.companyModalForm.openForm(data.result);
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
        }        
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
      }
  }

  public companyDataHasBeenSaved() {
    try {
      this.companyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormHasBeenCancelled() {
    try {
      this.companyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cellClick(e : any) {
    try {
      if (e != undefined)
      {
        if (e.column.name == "company") {
          this.companyClick(e.row.data["company"])
        }
  
        if (e.column.name == "iccid") {
          this.iccidClick(e.row.data["id"])
        } 

        //CRN_20260130 - This does not look to be wired up
        if (e.column.name == "fullName") {
          this.userClick(e.row.data["companyName"], e.row.data["username"])
        } 
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public iccidClick(orderId: number | undefined) {
    try {
      if (!this.manageEsimFormIsOpen) {
      
        if (orderId==undefined || <number>orderId<=0) {
          throw new Error("DevicesAllocatedComponent..SureSIM OrderID cannot be determined");
        }
        
        this.manageEsimFormIsOpen=true;
        this.manageEsimModalForm.openForm(orderId);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridMoreButtonClick(e:any) {
    try {
      if(!this.ticketNotesModalFormIsOpen){
        this.ticketNotesModalFormIsOpen = true;
        this.ticketNotesModalForm.openForm(e.row.data as Ticket);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onCheckboxChange(value: boolean | number | string): void {
    try {
      const on=value===true;

      this.dgProperties!.checkbox0!.value   =value;
      this.dgProperties!.columnHidingEnabled=!on;
      this.dgProperties!.columnMinWidth     =on ? this.columnMinWidth : undefined;

      this.gridView.setColumnHidingEnabled(!on);
      this.gridView.setColumnMinWidth(this.dgProperties!.columnMinWidth, this.dgActionColumn!.width);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userClick(companyName: string, username : string) {
    try {
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
        
      this.companiesService.getIdByCompanyName(companyName)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            const companyId: number=data.result;

            this.usersService.getIdByUsername(companyId, username)
            .pipe(
              catchError((error) => {
                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
              })
            )
            .subscribe({
              next: data => {
                this.userModalForm.openForm(data.result, eUser.sim);
              },
              error: error => {
                this.exceptionsService.handleException(new Error(error));
              }
            });
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userFormHasBeenCancelled() {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userFormHasBeenSaved() {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ticketFormHasBeenCancelled() {
    try {
      this.ticketModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async ticketFormHasBeenSaved(): Promise<void> {
    try {
      this.ticketModalFormIsOpen=false;
      await this.onTabChange(this.activeId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridAddButtonClick(e: any){
    try {
      if (this.newCompany && !this.enableSupportOnNew) {
        this.informationModalForm.openForm("Information", "Please save the company details before creating a ticket");
      } else if (this.newUser && !this.enableSupportOnNew) {
        this.informationModalForm.openForm("Information", "Please save the user details before creating a ticket");
      } else if (this.newSim && !this.enableSupportOnNew) {
        this.informationModalForm.openForm("Information", "Please save the sim details before creating a ticket");
      } else {
        if (!this.ticketModalFormIsOpen) {
          this.ticketModalFormIsOpen=true;
          
          this.companiesService.getForLoggedInUser(this.curUserID)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.ticketModalForm.openForm(data, this.isCompany, this.isDevice, this.isUser, this.matchCompanyAndUser, this.initialInviewCompanyId ?? -1, this.initialInviewUserId ?? -1, this.initialSureSimDeviceId ?? -1);
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
        }  
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ticketNoteFormHasBeenCancelled() {
    try {
      this.ticketNotesModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async ticketNoteFormHasBeenSaved(): Promise<void> {
    try {
      this.ticketNotesModalFormIsOpen=false;
      await this.onTabChange(this.activeId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
